

import moment from 'moment';
import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import {ListCustomer} from "@/models/listCustomer";
import zaloRepository from "@/services/ZaloRepository";
import {FilterMatchMode} from "primevue/api";
import {ManagerCheckinCreate} from "@/models/managerCheckinCreate";
import {ManagerCheckin} from "@/models/managerCheckin";
import {CarObject} from "@/models/carObject";
import {Ds_Cls} from "@/models/ds_Cls";
import {FileDetail} from "@/models/fileDetail.models";
import axios from "axios";
import {Cls} from "@/models/cls";

export default {

  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const maYTe = ref("");
    const listCLS = ref([] as Ds_Cls[]);
    const listFileCls = ref([] as Cls[]);
    const ngaySinh = ref("")
    const permissionCLS = ref(false);

    if((store.state.permission == 'cls')){
      permissionCLS.value = true;
    }

    const loadListCls = () => {
      console.log("#####$$$$$$$$$$ loadListCls: " );
      zaloRepository.getDanhSachCls(maYTe.value)
          .then((response) => {
            console.log("#####$$$$$$$$$$ loadListCls 0000000: " );
            listCLS.value = response.data;
            console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(listCLS.value));
            console.log("#####$$$$$$$$$$ listCLS.value.length: " + listCLS.value.length);
            if(listCLS.value[0].ngaysinh != null)
            {
              ngaySinh.value = formatDate(listCLS.value[0].ngaysinh);
            }
            console.log("#####$$$$$$$$$$ listCLS.value.length aaaa: ");

            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  console.log("#####$$$$$$$$$$ getListCLS: " + JSON.stringify(response.data));
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                   x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          })
          .catch(err => {
            console.log("#####$$$$$$$$$$ loadListCls 1111111: " );
            console.log("#####$$$$$$$$$$ loadListCls 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ loadListCls 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatDateTime = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm:ss DD/MM/YYYY');
    };

    const formatDate = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('DD/MM/YYYY');
    };
    const listLink = ref([] as string[]);
    let listFileName = ref([] as FileDetail[]);
    const loadingBar = ref(false);
    const upload = () => {
      {
        // listCLS.value[0].sodienthoai = "0905333122"; // debug
        // listCLS.value[0].sodienthoai = "0905123456"; // debug
        listLink.value = [];
        var files = new FormData();
        listFileName.value.forEach(x =>
        {
          files.append("formFiles", x.value, x.nameFile);
        });
        loadingBar.value = true;
        axios.defaults.headers.common = {'Authorization': `Bearer ${store.state.token}`}
        axios.post(`../api/File/UploadFileCLS/${listCLS.value[0].sodienthoai}/${maYTe.value}`, files,
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
              }
            }).then(response => {

          loadingBar.value = false;
          listFileName.value = [];
          if(response.data.status) {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Tải kết quả thành công',
              life: 2000
            });
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          }
          else{
            toast.add({
              severity: 'warn',
              summary: 'Lỗi',
              detail:response.data.log,
              life: 2500
            });
          }
        })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })});
      }
    };

    const fileChange = (fileList) => {
      var leng = fileList.length;
      for (var i = 0; i < leng; i++)
      {
        var filetemp = ref({} as FileDetail);
        filetemp.value.nameFile = fileList[i].name;
        filetemp.value.value = fileList[i];
        listFileName.value.push(filetemp.value);
      }
    };

    const sendFileResult = (id: number) => {
      console.log("#####$$$$$$$$$$ sendResult: " );
      zaloRepository.sendResult(id)
          .then((response) => {
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          })
          .catch(err => {
            console.log("#####$$$$$$$$$$ sendFileResult 1111111: " );
            console.log("#####$$$$$$$$$$ sendFileResult 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ sendFileResult 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    return {
      error,
      filters,
      clearFilter,
      initFilters,
      maYTe,
      formatDateTime,
      listCLS,
      loadListCls,
      ngaySinh,
      upload,
      listLink,
      listFileName,
      loadingBar,
      fileChange,
      listFileCls,
      sendFileResult,
      permissionCLS
    }
  }
}

